import { IcoAdd } from "assets/icons";
import { Button, RegisterItem } from "components";
import { ModalDriverDelete } from "components/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPartnerUuid } from "services/auth";
import { deleteDriver, getDrivers } from "services/driver";
import { setStep } from "store/features/registration/slice";
import styles from "./styles.module.scss";

export default function ManageDriversPage() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [drivers, setDrivers] = useState<any[]>([]);
	const [partnerId, setPartnerId] = useState("");

	const [showModalDriverDelete, setShowModalDriverDelete] = useState(false);
	const [selectedDriverId, setSelectedDriverId] = useState<string>("");

	const fetchData = async () => {
		const partnerUuid = (await getPartnerUuid()) || "";
		setPartnerId(partnerUuid);

		const result: any[] = (await getDrivers(partnerUuid || "")) || [];

		if (result) {
			setDrivers(result);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	const handleEdit = (id: string) => {
		navigate(`/cadastro/motoristas/${id}/editar`);
	};

	const handleDelete = async (id: string) => {
		await deleteDriver(partnerId, id);
		await fetchData();
	};

	return (
		<form className={styles.form}>
			<ModalDriverDelete
				open={showModalDriverDelete}
				onClose={() => setShowModalDriverDelete(false)}
				onAgree={() => {
					handleDelete(selectedDriverId);
					setShowModalDriverDelete(false);
				}}
			/>
			<div className={styles.container}>
				{drivers.map((driver) => (
					<RegisterItem
						key={driver.id}
						title={driver.name}
						subtitle={driver.document}
						onEdit={() => handleEdit(driver.id)}
						onDelete={() => {
							setSelectedDriverId(driver.id);
							setShowModalDriverDelete(true);
						}}
					/>
				))}
				<div className={styles.addButtonWrapper}>
					<Button
						type="button"
						variant="outline"
						onClick={() => {
							navigate("/cadastro/motoristas/novo");
						}}
					>
						<div className={styles.addButton}>
							<IcoAdd />
						</div>
						Novo motorista
					</Button>
				</div>
			</div>
			<div className={styles.buttonWrapper}>
				<Button
					type="button"
					onClick={() => {
						navigate("/cadastro/contas");
						dispatch(setStep(4));
					}}
				>
					Próxima
				</Button>
			</div>
		</form>
	);
}
